import { useTranslation } from "react-i18next";

const PeriodFilter = ({ activePeriod, onChange }) => {
    const { t } = useTranslation();

    const periods = [
        { id: 'week', label: t('common.week') },
        { id: 'month', label: t('common.month') },
        { id: 'all', label: t('common.all') }
    ];

    return (
        <div className="flex space-x-1 sm:space-x-2 p-1 bg-gray-100 dark:bg-gray-800 rounded-lg">
            {periods.map(period => (
                <button
                    key={period.id}
                    onClick={() => onChange(period.id)}
                    className={`px-2 py-1 sm:px-3 sm:py-1.5 text-xs sm:text-sm rounded-md transition-all ${activePeriod === period.id
                        ? 'bg-indigo-500 text-white shadow-md'
                        : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600'
                        }`}
                >
                    {period.label}
                </button>
            ))}
        </div>
    );
};

export default PeriodFilter;